import { render, staticRenderFns } from "./ItemEmpleado.vue?vue&type=template&id=37216b78&"
import script from "./ItemEmpleado.vue?vue&type=script&lang=js&"
export * from "./ItemEmpleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports